module.exports = __webpack_public_path__ + "static/media/preview-btn.e4a9f92b.svg";